
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import TopPanel from 'containers/TopPanel'
import {StickyContainer} from 'react-sticky'
import isFunction from 'lodash/isFunction'
import {formatPattern} from 'react-router/lib/PatternUtils'

export default class AnalyticsLayout extends React.Component {
  static propTypes = {
    route: PropTypes.object,
    routes: PropTypes.arrayOf(PropTypes.object),
    params: PropTypes.object,
    menu: PropTypes.node,
    main: PropTypes.node
  }

  render() {
    const {menu, routes} = this.props
    const routesDetails = this.getRoutesDetails()
    const title = routesDetails.length ? routesDetails.pop().title : ''
    const route = routes.concat().pop()
    const {withBreadcrumbs, disableDatePicker} = route

    return (
      <div className='analytics-layout'>
        <StickyContainer className='analytics-layout_sticky-container'>
          <TopPanel
            title={title}
            menu={menu}
            breadcrumbs={withBreadcrumbs ? routesDetails : null}
            datePicker={!disableDatePicker} />
          {this.props.children || this.props.main}
        </StickyContainer>
      </div>
    )
  }

  getRoutesDetails() {
    const {route, routes, params} = this.props
    const fullPath = []

    return routes.concat()
      .splice(routes.indexOf(route), routes.length)
      .reduce((acc, r) => {
        if (!r.title) return acc

        fullPath.push(r.path)
        return acc.concat({
          title: isFunction(r.title) ? r.title(params) : r.title,
          path: `/${formatPattern(fullPath.join('/'), params)}`
        })
      }, [])
  }
}



// WEBPACK FOOTER //
// ./client/layouts/AnalyticsLayout/index.js